<template>
	<div>
		<Card v-if="results">
			<p slot="title" v-html="results.subject"></p>
			<p
				class="c-message-templates__preview"
				v-html="results.bodyHtml"
			></p>
		</Card>
		<loading-component v-else></loading-component>
	</div>
</template>
<script>
export default {
	props: {
		results: Object,
	},
};
</script>
